<template>
  <div>
    <el-steps align-center :active="workflow.pasos.length">
      <el-step :title="`Paso ${index}`" v-for="(paso, index) in workflow.pasos" :key="index">
        <template slot="description">
          <li style="list-style:none;" v-for="(item, index) in paso.roles" :key="index">
            <b>{{bhpProfiles[item]}}</b>
            <div></div>
            <span>{{getUsers(item)}}</span>
          </li>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "workflow2",
  props: ["workflow", "contract"],
  data() {
    return {
      bhpProfiles: {
        hse: "Asesor SSO",
        health: this.$t("Especialista de Salud"),
        safety: this.$t("Especialista de Seguridad"),
        environment: this.$t("Especialista de Medioambiente"),
        contractor_hse: this.$t("Asesor SSO Contratista"),
        owner: this.$t("Dueño de Contrato"),
        contract_owner: this.$t("Dueño de Contrato"),
        risk: this.$t("Especialista de Riesgo"),
        administrator: this.$t("Administrador de Contrato"),
        contractor_coordinator: this.$t("Coordinador Contratista"),
        coordinator: this.$t("Coordinador"),
        manager: this.$t("Gerente de Área"),
        super: this.$t("Superintendente de Área"),
        general_manager: this.$t("Gerente General")
      }
    };
  },
  computed: {
    ...mapGetters({
      areasTree: "areas"
    }),
    area() {
      return this.areasTree.find(area => area._id === this.contract.area_id);
    }
  },
  methods: {
    getUsers(rol) {
      if (!this.contract) {
        return "";
      } else {
        if (this.contract.revisores[rol]) {
          let users = [];
          this.contract.revisores[rol].forEach(u => {
            users.push(this.getUser(u));
          });
          return users.join(" - ");
        } else {
          if (rol === "super") {
            return this.getUser(this.area.super_id);
          }
          if (rol === "manager") {
            return this.getUser(this.area.manager_id);
          }
        }
      }
    },
    getUser(id) {
      let findUser = "";
      this.$store.getters.usersFaena.forEach(user => {
        if (user._id === id) {
          findUser = `${user.nombre} ${user.apellido}`;
        }
      });
      return findUser;
    }
  }
};
</script>


<style scoped>
.el-card {
  border: 2px solid #f89559;
}
.el-card__header {
  padding: 18px 20px;
  border-bottom: 1px solid #f89559;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
